/*
 * ParticipantDetailFrame.jsx 02.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import GoalListControls from '../../containers/detail/GoalListControls';
import Sidebar from './Sidebar';
import GoalDetailsFrame from './GoalDetailsFrame';

const styles = theme => ({
    paper: {
        display: 'grid',
        gridTemplateColumns: '50px 600px auto',
        gridTemplateAreas: '"sidebar goalList goalDetails"',
        minHeight: '400px',
        margin: '0 auto',
        width: '2000px',
        [theme.breakpoints.down(2000)]: {
            width: '1800px'
        },
        [theme.breakpoints.down(1850)]: {
            width: '1600px'
        },
        [theme.breakpoints.down(1650)]: {
            width: '1400px'
        },
        [theme.breakpoints.down(1450)]: {
            width: '1200px'
        },
        [theme.breakpoints.down(1250)]: {
            width: '1000px'
        },
        [theme.breakpoints.down(1050)]: {
            width: '800px'
        },
        [theme.breakpoints.down(850)]: {
            width: '600px'
        },
        [theme.breakpoints.down(650)]: {
            width: '400px'
        }
    },

    goalListFrame: {
        gridArea: 'goalList',
        background: 'linear-gradient(135deg, #6A6B7F 0%, #4B4B5D 100%)',
        paddingBottom: '10px'
    },

    detailFrame: {
        gridArea: 'goalDetails',

        borderTopRightRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,

        backgroundColor: '#F9F9FC',
        overflowY: 'auto'
    }
});



class ParticipantDetailFrame extends React.Component {

    render() {
        const {classes, participant, goalList, selectedGoal} = this.props;

        return (
            <Paper className={classes.paper} elevation={2}>
                <Sidebar />

                <div className={classes.goalListFrame}>
                    <GoalListControls participant={participant} goalList={goalList} selectedGoal={selectedGoal} />
                </div>

                <div className={classes.detailFrame}>
                    <Toolbar variant="dense">
                        <Typography variant="title" color="primary" style={{textTransform: 'uppercase'}}>Zieldetails</Typography>
                    </Toolbar>

                    <GoalDetailsFrame goal={selectedGoal} />
                </div>
            </Paper>
        );
    }
}

export default withStyles(styles)(ParticipantDetailFrame);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/ParticipantDetailFrame.jsx